import { createFeatureSelector, createSelector } from '@ngrx/store'
import * as reducer from './notification.reducer'
import * as state from './notification.state'
import { selectAllRentals, selectRentalEntities } from '@tokeet-frontend/tv3-platform'
import { Rental } from '@tokeet-frontend/tv3-platform'
import { Notification } from '@tv3/store/notification/notification.model'
import * as R from 'ramda'
import { Guest } from '@tv3/store/guest/guest.model'
import { selectAllGuests, selectGuestEntities } from '@tv3/store/guest/guest.selectors'

export const notificationState = createFeatureSelector<state.State>('notification')

export const selectAllNotifications = createSelector(notificationState, reducer.selectAll)

export const selectNotificationsLoaded = createSelector(notificationState, (state: state.State) => state.isLoaded)
export const selectNotificationsLoading = createSelector(notificationState, (state: state.State) => state.isLoading)
export const selectNotificationUnreadCount = createSelector(
  notificationState,
  (state: state.State) => state.unreadCount
)
export const selectNotificationUnreadCountLoaded = createSelector(
  notificationState,
  (state: state.State) => state.isUnreadCountLoaded
)
export const selectNotificationUnreadCountLoading = createSelector(
  notificationState,
  (state: state.State) => state.isUnreadCountLoading
)

export const selectNotificationsWithRentals = createSelector(
  selectRentalEntities,
  selectGuestEntities,
  selectAllNotifications,
  (rentalEntities, guestEntities, notifications) => {
    return R.map((n: Notification) => {
      const rental: Rental = rentalEntities[n.rentalId]
      const guest: Guest = guestEntities[n.guestId]

      return { ...n, rental, guest } as Notification
    }, notifications)
  }
)

export const selectNotificationByLinkType = createSelector(
  selectAllNotifications,
  (notifications: Notification[], props) => {
    return R.filter((notification) => {
      return notification.linkType === props.type
    }, notifications || [])
  }
)
